import {apiCall} from 'library';

export function getTaskStatus(task_id) {
    return apiCall(`/api/mgmt/task_status/${task_id}`);
}

export function getTasksList() {
    return apiCall(`/api/mgmt/tasks`);
}
